import { HTTP } from '@/axios_api/http-common'

const state = {
    budgetTemplates : []
}

interface IState {
    budgetTemplates: any[]
}

const getters = {
    getAllTemplates (state: IState) {
        return state.budgetTemplates
    }
}

const mutations = {
    createBudgetTemplate(state: IState, payload: any) {
        state.budgetTemplates.push(payload);
    },
    editBudgetTemplate(state:IState, update: any) {
        for (let index = 0; index < state.budgetTemplates.length; index++) {
            if(state.budgetTemplates.indexOf(state.budgetTemplates[index]) == update.id) {
                state.budgetTemplates[index] = update;
                break;
            }
        }
    },
    setBudgetTemplate(state: IState,  budgetTemplates: any) {
        state.budgetTemplates = budgetTemplates
    },
    removeBudgetTemplate(state: IState, deletedIds: string[]) {
        state.budgetTemplates = state.budgetTemplates.filter((template) => !deletedIds.includes(template.id.toString()));
    },
}

const actions = {
    fetchBudgetTemplates({commit}: {commit: any}) {
        return new Promise((resolve, reject) => {
            HTTP.get('budgettemplate').then((response: any) => {
                commit('setBudgetTemplate', response.data.data )
                resolve(response)
            }).catch((error: any) => {
                reject(error)
            })
        })
    },
    createNewBudgetTemplate({commit}: {commit: any}, payload: any) {
        return new Promise((resolve, reject) => {
            HTTP.post('budgettemplate/create', payload).then((response: any) => {
                commit('createBudgetTemplate', response.data.data)
                resolve(response)
            }).catch((error: any) => {
                reject(error)
            })
        })
    },
    updateBudgetTemplate({commit} : {commit: any}, payload: any) {
        return new Promise((resolve, reject) => {
            HTTP.put('budgettemplate/update/' + payload.id, payload).then((response: any) => {
                commit('editBudgetTemplate', payload)
                resolve(response)
            }).catch((error: any) => {
                reject(error)
            })
        })
    },
    deleteBudgetTemplate({commit}:{commit: any}, templateIds: string[]) { 
        return new Promise ((resolve, reject) => {
            HTTP.delete('budgettemplate/delete', {data: templateIds}).then((response: any) => {
                commit('removeBudgetTemplate', templateIds)
                resolve(response)
            }).catch((error: any) => {
                reject(error)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}